module.exports = __webpack_public_path__ + "asset/image/connect-type-3baf.svg";